import { render, staticRenderFns } from "./LetturaReferto.vue?vue&type=template&id=fe9f016c&"
import script from "./LetturaReferto.vue?vue&type=script&lang=js&"
export * from "./LetturaReferto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports